import request from '@/utils/request'

// download file
export const getFile = (data) => {
  return request({
    url: '/api/file/getFile',
    method: 'get',
    params:data,
    responseType: 'blob',
    vconfig:{
      noErr:true,
      responseType:'blob'
    }
  })
}

export const getAbi = (name) => {
  return request({
    url: `/api/contracts/abi`,
    method: 'get',
    params: { name },
  })
}

export const availableList = () => {
  return request({
    url: `/api/dapps/availableList`,
    method: 'get',
  })
}




